import { createRouter, createWebHistory } from "vue-router";

// Stores
import { useAuthStore } from "@/stores";

// Views
import {
  UI,
  LoginView,
  ProgramsView,
  ProgramsIncubeView,
  ProgramsInpulseView,
  ProgramsInspireView,
  ReviewerPanelView,
  MyProfileView,
  ForgotPasswordView,
  ResetPasswordView,
  NewSpecialtyView,
  NewMonitorView,
  NewInstituteView,
  NewEdictView,
  EditEdictView,
  EditInstituteView,
  EditSpecialtyView,
  EditMonitorView,
  EditReviewerView,
  ContinuosFlowView,
  NewProgramInCubeView,
  NewProgramInPulseView,
  NewProgramInSpireView,
  NewReviewerView,
  ProposerPanelView,
  ProposerProposalView,
  ProposerProjectView,
  ProposerProjectsView,
  ProposerFirstAccessView,
  ReviewerFirstAccessView,
  ReviewerProposalView,
  ReviewerSelectionView,
  MonitorProposalView,
  MonitorProposalsView,
  MonitorProjectView,
  MonitorProjectsView,
  MonitorFirstAccessView,
} from "@/views";

import {
  InovahcProgramView,
  InovahcProgramsView,
  InovahcProjectsView,
  InovahcProjectView,
  InovahcEdictsView,
  InovahcInstituteProjectsView,
  InovahcInstituteView,
  InovahcInstitutesView,
  InovahcSpecialtiesView,
  InovahcMonitorView,
  InovahcMonitorsView,
  InovahcMonitorProjectsView,
  InovahcReviewerView,
  InovahcReviewersView,
  InovahcProposerView,
  InovahcProposerProjectsView,
  InovahcProposersView,
  InovahcProposalView,
  InovahcProposalReviewerView,
  InovahcFormsDownloadView,
} from "@/views/inovahc_panel";

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }; // always scroll to top
  },
  linkActiveClass: "active",
  routes: [
    { path: "/", component: ProgramsView, name: "home", meta: { title: "Home" } },
    
    { path: "/ui", component: UI, name: "ui", meta: { title: "UI" } },
    
    { path: "/programas", component: ProgramsView, name: "programas", meta: { title: "Programas" } },
    { path: "/programas-incube", component: ProgramsIncubeView, name: "programas-incube", meta: { title: "Programa inCube" } },
    { path: "/programas-inpulse", component: ProgramsInpulseView, name: "programas-inpulse", meta: { title: "Programa imPulse" } },
    { path: "/programas-inspire", component: ProgramsInspireView, name: "programas-inspire", meta: { title: "Programa inspire" } },
    
    { path: "/login", component: LoginView, name: "login", meta: { withoutFooter: true, title: "Login" }},
    { path: "/esqueci-minha-senha", component: ForgotPasswordView, name: "esqueci-minha-senha", meta: { withoutFooter: true, title: "Esqueci minha senha" }},
    { path: "/nova-senha/:token", component: ResetPasswordView, name: "nova-senha", params: { token: "token" }, meta: { withoutFooter: true, title: "Nova senha" }},
    { path: "/meu-perfil", component: MyProfileView, name: "meu-perfil", meta: { title: "Meu perfil" }},

    { path: "/primeiro-acesso-proponente", component: ProposerFirstAccessView, name: "primeiro-acesso-proponente", meta: { withoutFooter: true, title: "Primeiro acesso proponente" }},
    { path: "/primeiro-acesso-parecerista/:token", component: ReviewerFirstAccessView, name: "primeiro-acesso-parecerista", params: { token: "token" }, meta: { withoutFooter: true, title: "Primeiro acesso parecerista" }},
    { path: "/primeiro-acesso-monitor/:token", component: MonitorFirstAccessView, name: "primeiro-acesso-monitor", params: { token: "token" }, meta: { withoutFooter: true, title: "Primeiro acesso monitor" }},

    //
    { path: "/painel-inovahc/programa/:id", component: InovahcProgramView, name: "painel-inovahc-programa", params: { id: true }, meta: { title: "Programa | Administração" }},
    { path: "/painel-inovahc/programas", component: InovahcProgramsView, name: "painel-inovahc-programas", meta: { title: "Programas | Administração" }},
    { path: "/painel-inovahc/projetos", component: InovahcProjectsView, name: "painel-inovahc-projetos", meta: { title: "Projetos | Administração" }},
    { path: "/painel-inovahc/projeto/:id", component: InovahcProjectView, name: "painel-inovahc-projeto", params: { id: true }, meta: { title: "Projeto | Administração" }},
    { path: "/painel-inovahc/editais", component: InovahcEdictsView, name: "painel-inovahc-editais", meta: { title: "Editais | Administração" }},
    { path: "/painel-inovahc/instituto/:id", component: InovahcInstituteView, name: "painel-inovahc-instituto", params: { id: true }, meta: { title: "Instituto | Administração" }},
    { path: "/painel-inovahc/instituto/:id/projetos", component: InovahcInstituteProjectsView, name: "painel-inovahc-instituto-projetos", params: { id: true }, meta: { title: "Projetos do instituto | Administração" }},
    { path: "/painel-inovahc/institutos", component: InovahcInstitutesView, name: "painel-inovahc-institutos", meta: { title: "Institutos | Administração" }},
    { path: "/painel-inovahc/especialidades", component: InovahcSpecialtiesView, name: "painel-inovahc-especialidades", meta: { title: "Especialidades | Administração" }},
    { path: "/painel-inovahc/monitor/:id", component: InovahcMonitorView, name: "painel-inovahc-monitor", params: { id: true }, meta: { title: "Monitor | Administração" }},
    { path: "/painel-inovahc/monitor/:id/projetos", component: InovahcMonitorProjectsView, name: "painel-inovahc-monitor-projetos", params: { id: true }, meta: { title: "Projetos do monitor | Administração" }},
    { path: "/painel-inovahc/monitores", component: InovahcMonitorsView, name: "painel-inovahc-monitores", meta: { title: "Monitores | Administração" }},
    { path: "/painel-inovahc/parecerista/:id", component: InovahcReviewerView, name: "painel-inovahc-parecerista", params: { id: true }, meta: { title: "Parecerista | Administração" }},
    { path: "/painel-inovahc/pareceristas", component: InovahcReviewersView, name: "painel-inovahc-pareceristas", meta: { title: "Pareceristas | Administração" }},
    { path: "/painel-inovahc/proponente/:id", component: InovahcProposerView, name: "painel-inovahc-proponente", params: { id: true }, meta: { title: "Proponente | Administração" }},
    { path: "/painel-inovahc/proponente/:id/projetos", component: InovahcProposerProjectsView, name: "painel-inovahc-proponente-projetos", params: { id: true }, meta: { title: "Projetos do proponente | Administração" }},
    { path: "/painel-inovahc/proponentes", component: InovahcProposersView, name: "painel-inovahc-proponentes", meta: { title: "Propostos | Administração" }},
    { path: "/painel-inovahc/proposta/:id", component: InovahcProposalView, name: "painel-inovahc-proposta", params: { id: true }, meta: { title: "Proposta | Administração" }},
    { path: "/painel-inovahc/proposta/:id/selecionar-parecerista", component: InovahcProposalReviewerView, name: "painel-inovahc-proposta-parecerista", params: { id: true }, meta: { title: "Selecionar parecerista | Administração" }},
    { path: "/painel-inovahc/formularios-para-download", component: InovahcFormsDownloadView, name: "painel-inovahc-formularios-para-download", meta: { title: "Formularios para download | Administração" }},

    { path: "/adicionar-especialidade", component: NewSpecialtyView, name: "adicionar-especialidade", meta: { title: "Adicionar especialidade | Administração"}},
    { path: "/editar-especialidade/:id", component: EditSpecialtyView, name: "editar-especialidade", meta: { title: "Editar especialidade | Administração"}},
    { path: "/adicionar-monitor", component: NewMonitorView, name: "adicionar-monitor", meta: { title: "Adicionar monitor | Administração"}},
    { path: "/editar-monitor/:id", component: EditMonitorView, name: "editar-monitor", meta: { title: "Editar monitor | Administração"}},
    { path: "/adicionar-instituto", component: NewInstituteView, name: "adicionar-instituto", meta: { title: "Adicionar instituto | Administração"}},
    { path: "/editar-instituto/:id", component: EditInstituteView, name: "editar-instituto", meta: { title: "Editar instituto | Administração"}},
    { path: "/adicionar-edital", component: NewEdictView, name: "adicionar-edital", meta: { title: "Adicionar edital | Administração"}},
    { path: "/editar-edital/:id", component: EditEdictView, name: "editar-edital", meta: { title: "Editar edital | Administração"}},


    { path: "/painel-proponente", component: ProposerPanelView, name: "painel-proponente", meta: { title: "Meu painel | Proponente"}},
    { path: "/painel-proponente/proposta/:id", component: ProposerProposalView, name: "painel-proponente-proposta", params: { id: true }, meta: { title: "Proposta | Proponente" }},
    { path: "/painel-proponente/projeto/:id", component: ProposerProjectView, name: "painel-proponente-projeto", params: { id: true }, meta: { title: "Projeto | Proponente" }},
    { path: "/painel-proponente/projetos", component: ProposerProjectsView, name: "painel-proponente-projetos", params: { id: true }, meta: { title: "Projetos | Proponente" }},
    { path: "/criar-proposta", component: ContinuosFlowView, name: "adicionar-programa", meta: { title: "Adicionar proposta | Proponente"}},
    { path: "/criar-proposta-incube", component: NewProgramInCubeView, name: "adicionar-programa-incube", meta: { title: "Adicionar proposta inCube | Proponente"}},
    { path: "/criar-proposta-inpulse", component: NewProgramInPulseView, name: "adicionar-programa-inpulse", meta: { title: "Adicionar proposta imPulse | Proponente"}},
    { path: "/criar-proposta-inspire", component: NewProgramInSpireView, name: "adicionar-programa-inspire", meta: { title: "Adicionar proposta inspire | Proponente"}},
    { path: "/editar-proposta/:id", component: ContinuosFlowView, name: "editar-proposta", params: { id: true }, meta: { title: "Editar proposta | Proponente"}},
    { path: "/editar-proposta-incube/:id", component: NewProgramInCubeView, name: "editar-proposta-incube", params: { id: true }, meta: { title: "Editar proposta inCube | Proponente"}},
    { path: "/editar-proposta-inpulse/:id", component: NewProgramInPulseView, name: "editar-proposta-inpulse", params: { id: true }, meta: { title: "Editar proposta imPulse | Proponente"}},
    { path: "/editar-proposta-inspire/:id", component: NewProgramInSpireView, name: "editar-proposta-inspire", params: { id: true }, meta: { title: "Editar proposta inspire | Proponente"}},
    
    { path: "/painel-parecerista", component: ReviewerPanelView, name: "painel-parecerista", meta: { title: "Meu painel | Parecerista"}},
    { path: "/painel-parecerista/proposta/:id", component: ReviewerProposalView, name: "painel-parecerista-proposta", params: { id: true }, meta: { title: "Proposta | Parecerista" }},
    
    { path: "/painel-monitor", component: MonitorProposalsView, name: "painel-monitor", meta: { title: "Meu painel | Monitor"}},
    { path: "/painel-monitor/proposta/:id", component: MonitorProposalView, name: "painel-monitor-proposta", params: { id: true }, meta: { title: "Proposta | Monitor" }},
    { path: "/painel-monitor/projetos", component: MonitorProjectsView, name: "painel-monitor-projetos", meta: { title: "Projetos | Monitor" }},
    { path: "/painel-monitor/projeto/:id", component: MonitorProjectView, name: "painel-monitor-projeto", params: { id: true }, meta: { title: "Projeto | Monitor" }},
    { path: "/adicionar-parecerista", component: NewReviewerView, name: "adicionar-parecerista", meta: { title: "Adicionar parecerista | Monitor"}},
    { path: "/editar-parecerista/:id", component: EditReviewerView, name: "editar-parecerista", meta: { title: "Editar parecerista | Monitor"}},
    { path: "/selecionar-pareceristas/proposta/:id", component: ReviewerSelectionView, name: "selecionar-pareceristas-proposta", params: { id: true }, meta: { title: "Selecionar pareceristas | Monitor"}},
    
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  if (authStore.user?.tipo === "super-admin" && to.name === "home") {
    next({ name: "painel-inovahc-programas" });
    return;
  } else if (authStore.user?.tipo === "parecerista" && to.name === "home") {
    next({ name: "painel-parecerista" });
    return;
  } else if (authStore.user?.tipo === "proponente" && to.name === "home") {
    next({ name: "painel-proponente" });
    return;
  } else if (authStore.user?.tipo === "monitor" && to.name === "home") {
    next({ name: "painel-monitor" });
    return;
  }

  const publicPages = [
    "home",
    "login",
    "esqueci-minha-senha",
    "nova-senha",
    "programas",
    "programas-incube",
    "programas-inpulse",
    "programas-inspire",
    "primeiro-acesso-proponente",
    "primeiro-acesso-parecerista",
    "primeiro-acesso-monitor",
    "ui"
  ];
  const authRequired = !publicPages.includes(to.name);

  if (authRequired && !authStore.user) {
    authStore.returnUrl = to.fullPath;
    next({ name: "login" });
    return;
  }
  //   if (to.name == "nova-senha" && !authStore.token) {
  //     next({ name: "login" });
  //     return;
  //   }

  if (authStore.user && to.name === "login") {
    next({ name: "home" });
    return;
  }

  next();
});
